export default defineAppConfig({
  title: 'Pakt Media'
})
